import { getOrganizationId } from '@lib/graphql/variables/organizationId'
import { constructUrlWithOrgId } from '@mono/packages/utils/router'
import NextLink, { LinkProps } from 'next/link'
import React, {
  ForwardRefExoticComponent,
  RefAttributes,
  forwardRef
} from 'react'

export type ILinkProps = Omit<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  keyof LinkProps
> &
  LinkProps & {
    children?: React.ReactNode
  }

type ILink = ForwardRefExoticComponent<
  ILinkProps & RefAttributes<HTMLAnchorElement>
>

/* eslint-disable react/display-name */
const Link: ILink = forwardRef<HTMLAnchorElement, ILinkProps>(
  ({ children, href, ...rest }, ref) => {
    const orgId = getOrganizationId()

    const hrefWithOrgId = constructUrlWithOrgId({ orgId, url: href })

    return (
      <NextLink {...rest} ref={ref} href={hrefWithOrgId}>
        {children}
      </NextLink>
    )
  }
)

export default Link
